import { render, staticRenderFns } from "./HelpCenterHiddenScenariosChart.vue?vue&type=template&id=9b38cd5a&"
import script from "./HelpCenterHiddenScenariosChart.vue?vue&type=script&lang=js&"
export * from "./HelpCenterHiddenScenariosChart.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenterHiddenScenariosChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
